import { render, staticRenderFns } from "./usuarios-clientefacturacion.vue?vue&type=template&id=2f86f35a&scoped=true&"
import script from "./usuarios-clientefacturacion.vue?vue&type=script&lang=js&"
export * from "./usuarios-clientefacturacion.vue?vue&type=script&lang=js&"
import style0 from "./usuarios-clientefacturacion.vue?vue&type=style&index=0&id=2f86f35a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86f35a",
  null
  
)

export default component.exports